module.exports = __webpack_public_path__ + "images/stickers/star.4c68ea50e4ffeeb97df5.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/star.png
// module id = 1E9t
// module chunks = 2